import CancelButton from "@common/controls/Form/Buttons/Cancel";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons, type FormControlledRenderParams, FormField } from "@common/controls/Form/component";
import Select, { type OptionItem } from "@common/controls/Inputs/Select/component";
import { FormModalControlled } from "@common/controls/Modal/Modals/Form/component";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

export type ExportFormat = "csv" | "pdf";
export type ExportModalData = {
  format: ExportFormat;
};

type Props = {
  onClose: () => void;
  isVisible: boolean;
  submit: (data: ExportModalData) => Promise<void>;
  title?: string;
};
export default (props: Props) => {
  const i18n = useI18n();

  const defaultValues: ExportModalData = React.useMemo(
    () => ({
      format: "pdf"
    }),
    []
  );

  const exportOptions = React.useMemo(
    (): OptionItem<ExportFormat>[] => [
      { label: i18n.csv.toUpperCase(), value: "csv" },
      { label: i18n.pdf.toUpperCase(), value: "pdf" }
    ],
    [i18n]
  );

  return (
    <FormModalControlled
      defaultValues={defaultValues}
      isVisible={props.isVisible}
      onClose={props.onClose}
      submit={props.submit}
      title={props.title ?? i18n.export}
    >
      {({ values }: FormControlledRenderParams<ExportModalData>) => (
        <>
          <FormField
            Component={Select}
            componentProps={{ options: exportOptions }}
            isRequired
            name="format"
            value={values.format}
          />

          <FormButtons>
            <CancelButton />
            <SubmitButton>{props.title ?? i18n.export}</SubmitButton>
          </FormButtons>
        </>
      )}
    </FormModalControlled>
  );
};
